import {
  AppBar,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  ListItem,
  ListItemText,
  Toolbar,
} from "@mui/material";

import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../auth/context";
import api from "../../services/api";

import { formatarTempo } from "../../helpers/time";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import InfoIcon from "@mui/icons-material/Info";

export default function Ranking() {
  const usuario = useContext(AuthContext);
  const [dadosRanking, setDadosRanking] = useState([]);
  const [rankingSelecionado, setRankingSelecionado] = useState("");
  const [indexRankingSelecionado, setIndexRankingSelecionado] = useState(0);
  const [itemSelecionado, setItemSelecionado] = useState("");

  useEffect(() => {
    carregarRanking();
  }, []);

  const carregarRanking = () => {
    api
      .get("relatorios/ranking", { usuarioId: usuario.usuario.usuarioId })
      .then((res) => {
        setDadosRanking(res);
        setRankingSelecionado(res[indexRankingSelecionado]);
      })
      .catch(() =>
        console.log(
          "Não foi possível carregar o ranking. Verifique sua conexão e tente novamente."
        )
      );
  };

  const selecionarProximo = () => {
    const avancar = indexRankingSelecionado + 1;
    if (avancar < dadosRanking.length) {
      setIndexRankingSelecionado(avancar);
      setRankingSelecionado(dadosRanking[avancar]);
    }
  };
  const selecionarAnterior = () => {
    const voltar = indexRankingSelecionado - 1;
    if (voltar > -1) {
      setIndexRankingSelecionado(voltar);
      setRankingSelecionado(dadosRanking[voltar]);
    }
  };

  const handleClose = () => {
    setItemSelecionado("");
  };

  return (
    <>
      <AppBar position="fixed">
        <Toolbar
          style={{
            background: "#3d79bd",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Grid>
            <h2
              style={{
                fontWeight: "bolder",
                color: "white",
                fontFamily: "Gilroy-ExtraBold",
              }}
            >
              Ranking
            </h2>
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <br />
      <Grid
        style={{ display: "flex", color: "white", background: "#a3a3a3" }}
        alignItems="center"
        container
      >
        <Grid style={{ textAlign: "center" }} item xs={1}>
          <ArrowBackIcon
            onClick={() => selecionarAnterior()}
            style={{
              cursor: "pointer",
            }}
          />
        </Grid>

        <Grid
          style={{ textAlign: "center", fontFamily: "Gilroy-ExtraBold" }}
          item
          xs={10}
        >
          <h3>{rankingSelecionado.cicloNome}</h3>
        </Grid>

        <Grid style={{ textAlign: "center" }} item xs={1}>
          <ArrowForwardIcon
            onClick={() => selecionarProximo()}
            style={{
              cursor: "pointer",
            }}
          />
        </Grid>
      </Grid>
      <br />
      {rankingSelecionado && (
        <>
          {rankingSelecionado.itens.map((item, index) => (
            <>
              <br />
              <div style={{ padding: "0px 10px 0 10px" }}>
                <ListItem
                  sx={{
                    width: "100%",
                    bgcolor: definirCorIconeRanking(index + 1),
                    borderRadius: "20px",
                    color: index + 1 < 4 ? "white" : "#a3a3a3",
                  }}
                >
                  <ListItemText
                    primary={
                      <h3 style={{ fontFamily: "Gilroy-ExtraBold" }}>
                        {index + 1} - {item.profissionalNome}
                      </h3>
                    }
                    secondary={
                      <p
                        style={{
                          fontFamily: "Gilroy-ExtraBold",
                          color: index + 1 < 4 ? "white" : "#a3a3a3",
                        }}
                      >
                        {item.totalPontos}pts
                      </p>
                    }
                  />

                  <IconButton
                    sx={{
                      background: "#a3a3a3",
                      color: "#FFFF",
                      marginRight: 2,
                    }}
                    onClick={() => setItemSelecionado(item)}
                  >
                    <InfoIcon />
                  </IconButton>
                </ListItem>
              </div>
            </>
          ))}
        </>
      )}

      <Dialog
        open={itemSelecionado}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AppBar
          position="static"
          style={{ color: "white", background: "#6a7277" }}
        >
          <Toolbar>
            <Grid container>
              <Grid item xs={10} style={{ textAlign: "center" }}>
                <h2>{itemSelecionado.profissionalNome}</h2>
              </Grid>
              <Grid item xs={2}>
                <Button color="inherit" onClick={() => handleClose()}>
                  X
                </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid
              container
              style={{ paddingLeft: 15, fontFamily: "Gilroy-ExtraBold" }}
            >
              <Grid item xs={12}>
                <h4>Unidades finalizadas no prazo</h4>
              </Grid>
              <br />
              <Grid item xs={12}>
                {itemSelecionado.pontosFinalizadasDentroPrazo} unidades
              </Grid>
              <br />
              <br />

              <Grid item xs={12}>
                <h4>Unidades finalizadas fora do prazo</h4>
              </Grid>
              <br />
              <Grid item xs={12}>
                {itemSelecionado.pontosFinalizadasForaPrazo} unidades
              </Grid>
              <br />
              <br />

              <Grid item xs={12}>
                <h4>Tempo decorrido</h4>
              </Grid>
              <br />
              <Grid item xs={12}>
                {itemSelecionado.tempoDecorrido
                  ? formatarTempo(itemSelecionado.tempoDecorrido)
                  : "-"}
              </Grid>
              <br />
              <br />

              <Grid item xs={12}>
                <h4>Total de pontos</h4>
              </Grid>
              <br />
              <Grid item xs={12}>
                {itemSelecionado.totalPontos}pts
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}

const definirCorIconeRanking = (posicao) => {
  switch (posicao) {
    case 1:
      return "#FCBE2D";

    case 2:
      return "#94B2C3";

    case 3:
      return "#F08333";

    default:
      return "#e8e8e8";
  }
};
